import createIcon from '../../createIcon';

/**
 * @component @name CastForEducation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0gzQzEuOSAzIDEgMy45IDEgNVY4SDNWNUgyMVYxOUgxNFYyMUgyMUMyMi4xIDIxIDIzIDIwLjEgMjMgMTlWNUMyMyAzLjkgMjIuMSAzIDIxIDNaTTEgMThWMjFINEM0IDE5LjM0IDIuNjYgMTggMSAxOFpNMSAxNFYxNkMzLjc2IDE2IDYgMTguMjQgNiAyMUg4QzggMTcuMTMgNC44NyAxNCAxIDE0Wk0xIDEwVjEyQzUuOTcgMTIgMTAgMTYuMDMgMTAgMjFIMTJDMTIgMTQuOTIgNy4wNyAxMCAxIDEwWk0xMSAxMS4wOVYxMy4wOUwxNC41IDE1TDE4IDEzLjA5VjExLjA5TDE0LjUgMTNMMTEgMTEuMDlaTTE0LjUgNkw5IDlMMTQuNSAxMkwyMCA5TDE0LjUgNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CastForEducation = createIcon('CastForEducation', [
  [
    'path',
    {
      d: 'M21 3H3C1.9 3 1 3.9 1 5V8H3V5H21V19H14V21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM1 18V21H4C4 19.34 2.66 18 1 18ZM1 14V16C3.76 16 6 18.24 6 21H8C8 17.13 4.87 14 1 14ZM1 10V12C5.97 12 10 16.03 10 21H12C12 14.92 7.07 10 1 10ZM11 11.09V13.09L14.5 15L18 13.09V11.09L14.5 13L11 11.09ZM14.5 6L9 9L14.5 12L20 9L14.5 6Z',
      key: '9whv60',
    },
  ],
]);

export default CastForEducation;
